import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FallbackView } from '../../_metronic/partials';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import { MenuTestPage } from '../pages/MenuTestPage';

export function PrivateRoutes() {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'));
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'));
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'));
  const StreamPage = lazy(() => import('../modules/stream/StreamPage'));
  const LogsPage = lazy(() => import('../modules/logs/LogsPage'));
  const DevicePage = lazy(() => import('../modules/devices/DevicePage'));
  const AutomationPage = lazy(() => import('../modules/automations/AutomationPage'));
  const AnalyticsPage = lazy(() => import('../modules/analytics/AnalyticsPage'));
  const SettingsPage = lazy(() => import('../modules/settings/SettingsPage'));

  return (
    <Suspense fallback={<FallbackView />}>
      <Routes>
        <Route path="/dashboard" element={<DashboardWrapper />} />
        <Route path="/data-stream/*" element={<StreamPage />} />
        <Route path="/logs/*" element={<LogsPage />} />
        <Route path="/automation/*" element={<AutomationPage />} />
        <Route path="/devices/*" element={<DevicePage />} />
        <Route path="/analytics/*" element={<AnalyticsPage />} />
        <Route path="/settings/*" element={<AccountPage />} />
        <Route path="/crafted/pages/profile/*" element={<ProfilePage />} />
        <Route path="/crafted/pages/wizards" element={<WizardsPage />} />
        <Route path="/crafted/widgets" element={<WidgetsPage />} />
        <Route path="/crafted/account/*" element={<AccountPage />} />
        <Route path="/apps/chat" element={<ChatPage />} />
        <Route path="/menu-test" element={<MenuTestPage />} />
        {/* Default redirect when `/auth` is visited */}
        <Route path="/auth" element={<Navigate to="/dashboard" replace />} />
        {/* Default redirect when `/` is visited */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        {/* Catch-all 404 redirect */}
        <Route path="*" element={<Navigate to="/error/404" replace />} />
      </Routes>
    </Suspense>
  );
}
